var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7752 10.6896L7.08555 6.00001L11.7752 1.31038C12.0749 1.01061 12.0749 0.524609 11.7751 0.224883C11.4754 -0.0748934 10.9893 -0.0748934 10.6896 0.224883L6 4.91446L1.31038 0.224833C1.01066 -0.0749442 0.524608 -0.0749442 0.224832 0.224833C-0.074944 0.524609 -0.074944 1.01061 0.224832 1.31038L4.91445 6.00001L0.224832 10.6896C-0.074944 10.9894 -0.074944 11.4754 0.224832 11.7752C0.37472 11.9251 0.571176 12 0.767581 12C0.964038 12 1.16049 11.9251 1.31038 11.7752L6 7.08556L10.6896 11.7752C10.8395 11.9251 11.036 12 11.2324 12C11.4289 12 11.6253 11.9251 11.7752 11.7752C12.0749 11.4754 12.0749 10.9894 11.7752 10.6896Z",
    fill: "#29185E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.e2666993c3f29341b6b6f8265ba5ea21.svg";
export { ForwardRef as ReactComponent };